export default __webpack_public_path__ + "static/media/Angel members@2x-min.497ea25b.png";